import { TIPOS_SOLICITUD } from '@/model'

const defaultTextSize = 'text-xs md:text-base'

const states = {
  [TIPOS_SOLICITUD.REVOCATORIA]: {
    classes: 'bg-yellow-100 text-yellow-800',
  },

  [TIPOS_SOLICITUD.AUTORIZACION]: {
    classes: 'bg-blue-100 text-blue-800',
  },
  [TIPOS_SOLICITUD.REVOCATORIA_TOTAL]: {
    classes: 'bg-violet-100 text-violet-800',
  },
}

export default {
  props: {
    tipo: { type: Object, required: true },
    textSizeClass: { type: String, default: defaultTextSize },
  },

  computed: {
    colour() {
      return states[this.tipo.tipoSolicitudId].classes
    },

    textSize() {
      return this.textSizeClass || defaultTextSize
    },
  },

  render() {
    return (
      <span
        class={`inline-flex items-center rounded-full px-3 pb-px pt-0.5 font-medium ${this.textSize} ${this.colour}`}
      >
        {this.tipo.descripcion}
      </span>
    )
  },
}
